import { useTranslation } from "react-i18next";
import { useBookingDispatch } from "../../hooks/useBookingState";
import { toNum } from "../../utils/conf";
import QuantityCard from "../QuantityCard";
import { BookVal } from "../../utils/bookingUtils";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import { useEffect } from "react";

export const QuatityBookingRow = ({
  bookingAttributes,
  mode,
  label,
  dto,
  type,
  min,
  disabled,
}: {
  bookingAttributes: BookingAttributeDTO[];
  mode: "POPUP" | "FORM";
  label?: string;
  dto: BookingAttributeDTO;
  type: "ROW" | "CARD";
  min: number;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const { bookingPick, bookingPickLs } = useBookingDispatch({
    mode,
  });

  useEffect(() => {
    if (min && typeof dto?.value?.quantity === "undefined") {
      const y = BookVal.append(dto)({
        quantity: min,
      });
      y && bookingPick(y);
    }
  }, [min, dto]);
  const onChange = (quantity: number) => {
    const y = BookVal.append(dto)({
      quantity,
    });
    if (dto.productAttribute.name === "ADULT") {
      const defaultBooka = ProdAttrUtils.findDefaultBooka(bookingAttributes);
      const x = BookVal.age(defaultBooka)({
        age: "ADULT",
        quantity,
      });
      const ls: BookingAttributeDTO[] = [];
      if (x) ls.push(x);
      if (y) ls.push(y);
      ls.length && bookingPickLs(ls);
    } else {
      y && bookingPick(y);
    }
  };

  // return <div>{type}</div>
  if (type === "CARD") {
    return (
      <QuantityCard
        disabled={disabled}
        title={label && t(label)}
        value={toNum(dto.value?.quantity)}
        onChange={onChange}
      />
    );
  }
  return (
    <div className="flex items-center justify-between border-t border-[#DEDEDE] py-5">
      <p className="text-[0.875rem] font-normal leading-[1.625rem] text-[#232323]">
        {label && t(label)}
      </p>
      <QuantityCard
        disabled={disabled}
        className="!border-none !p-0"
        value={toNum(dto.value?.quantity)}
        onChange={onChange}
      />
    </div>
  );
};
